var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"btn-blue btn-blue-sm",attrs:{"disabled":_vm.loading},on:{"click":_vm.handleChangeImageLogo}},[_vm._v(_vm._s(_vm.$t('lang.cambiar.msg')))]),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/png, image/jpeg, image/jpg"},on:{"change":_vm.handleSelectFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }